const files = require.context('.', false, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  if (key === './index.js') return
  const item = files(key).default
  const str = key.match(/.\/(\S*).js/)[1]
  modules[str] = item
})
export default modules
